import {
    Dialog,
    DialogHeader,
    DialogBody,
    DialogFooter,
} from "@material-tailwind/react";

import { useEffect, useState } from "react";
import { CalendarDaysIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { useDispatch, useSelector } from "react-redux";
import ScrollToTop from "@/components/ScrollToTop";
import ShowLoader from "@/components/Loader";

import { fetchTimeLine } from "../../../store/slices/rfqSlice";
import Toaster from "@/components/Toaster";
import moment from "moment";
import { useTranslation } from "react-i18next";

export function TimeLineModal({ onClose, rfqId }) {
    const dispatch = useDispatch();
    const { t } = useTranslation('rfq');
    const { t: ct } = useTranslation("common");

    useEffect(() => {
        dispatch(fetchTimeLine(rfqId));
    }, [dispatch]);

    const { timeline, loading } = useSelector((state) => state.rfq);

    const firstTimelineDate =
        timeline?.length > 0
            ? timeline[0]?.created_at.split(",")[0]
            : null;

    const getCircleStyle = (status) => {
        switch (status) {
            case 'completed':
                return 'bg-gray-400';
            case 'delayed':
                return 'bg-red-500';
            default:
                return 'bg-gray-400';
        }
    };

    return (
        <Dialog open={true} handler={onClose} size="md" className="rounded-2xl p-0">
            {loading && <ShowLoader />}
            <ScrollToTop />

            <DialogHeader className="flex justify-between items-center px-6 py-4 border-b">
                <h2 className="text-2xl font-bold text-gray-900">
                    {t('timeline_title')}
                </h2>
                <button
                    onClick={onClose}
                    className="p-1 rounded-full text-gray-500 hover:bg-gray-100 transition"
                >
                    <XMarkIcon className="w-6 h-6" />
                </button>
            </DialogHeader>

            <DialogBody className="px-0 py-0 overflow-hidden flex flex-col max-h-[65vh]">
                {firstTimelineDate && (
                    <div className="text-center py-4 text-sm font-medium text-gray-500 bg-white border-gray-50 z-20 top-0 ">
                        {moment(firstTimelineDate).format("DD MMM YYYY")}
                    </div>
                )}

                <div className="overflow-y-auto px-6 flex-1">
                    <div className="relative pt-6 pb-10">
                        <div 
                            className="absolute top-0 left-2.5 h-full w-0.5 bg-gray-200" 
                            aria-hidden="true"
                        ></div>

                        {timeline?.map((item, index) => (
                            <div key={index} className="relative mb-6 pl-8 last:mb-0">
                                <div className={`absolute left-1 top-1 w-3 h-3 rounded-full border-2 border-white z-10 ${getCircleStyle(item.status)}`} />

                                <div className="flex justify-between items-start text-sm">
                                    <div className="pr-4 text-gray-800">
                                        {item?.message}
                                        {item?.status === 'delayed' && (
                                            <span className="ml-2 px-2 py-0.5 text-xs font-semibold bg-red-100 text-red-600 rounded-full inline-block">
                                                {item.status}
                                            </span>
                                        )}
                                    </div>
                                    <div className="text-right whitespace-nowrap text-xs text-gray-500">
                                        {moment(item?.created_at).format("DD MMM, YYYY hh:mm A")}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </DialogBody>
        </Dialog>
    );
}
export default TimeLineModal;
